import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DefendantInfo } from 'src/app/core/models/models';
import { ReferralInfoApiService } from '../service/referral-info-api.service';
import { DefendantInfoFormValue, QuickUpdate_DefendnatDetail, QuickUpdateDefendant_Request } from '../referral-info/referral-info.model';

@Injectable({ providedIn: 'root' })
export class DefendantState {
    //#region Injectables
    private apiservice = inject(ReferralInfoApiService);
    //#endregion

    //#region Privtae variables
    private sequenceNumber: number = 0;
    private dataSource = new BehaviorSubject<DefendantInfo | null>(null);
    //#endregion

    //#region 
    public data$ = this.dataSource.asObservable();
    public defendantId: string = "0";
    //#endregion
    setParameters(caseSequenceNumber: string, defendantId: string) {
        this.sequenceNumber = +caseSequenceNumber;
        this.defendantId = defendantId;
    }

    private createRequestForDefendantInfo(personDetails: DefendantInfoFormValue) {
        const defendantInfo: QuickUpdate_DefendnatDetail = {
            DefendantNumber: +this.defendantId,
            Ssn: personDetails.ssn,
            IsEntity: personDetails.entityFlag,
            FirstName: personDetails.firstName,
            Agency: personDetails.employer,
            MiddleName: personDetails.middleName,
            NameSuffix: personDetails.nameSuffix,
            LastName: personDetails.lastName,
            Phone: personDetails.phone,
            Address1: personDetails.address1,
            Address2: personDetails.address2,
            City: personDetails.city,
            State: personDetails.state,
            ZipCode: personDetails.zipCode,
            Race: personDetails.race.Value,
            Sex: personDetails.sex.Value,
            Height: personDetails.height,
            Weight: personDetails.weight,
            PlaceOfBirth: personDetails.placeOfBirth.Value,
            LocalId: personDetails.lid,
            StateId: personDetails.sid,
            FederalId: personDetails.fbiIdentifier,
            DateOfBirth: personDetails.dateOfBirth,
            Hair: personDetails.hairColor.Value,
            Eyes: personDetails.eyeColor.Value,
            LicenseState: personDetails.dlState,
            LicenseNumber: personDetails.dlNumber,
            LicenseClass: personDetails.dLClassification.Value,
            LicenseExpirationDate: personDetails.dLExpirationDate,
            InmateNumber: personDetails.inmateNumber,
            DefendantStatus: personDetails.defendantStatus.Value,
            Nationality: personDetails.nationality.Value,
            IsIntl: personDetails.intAddressFlag,
            Email: personDetails.email
        };

        const requestPayload: QuickUpdateDefendant_Request = {
            DefendantInfo: defendantInfo,
            SequenceNumber: this.sequenceNumber
        };

        return requestPayload;
    }

    public continueDefendantInfo(personDetails: DefendantInfoFormValue) {
        const requestPayload = this.createRequestForDefendantInfo(personDetails);

        return this.apiservice.continueDefendnatInfo(requestPayload);
    }

    public loadDetails(defendantInfo: DefendantInfo) {
        this.dataSource.next(defendantInfo);
    }

}